import { PageLayout, useBrowserTitle } from '@acp/core-ui';
import React, { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';

const PortfolioPage = React.lazy(() => import('../features/portfolio/page'));
const NewManagementsPage = React.lazy(() => import('../features/integrated-portfolio/page'));

export function Portfolio() {
    useBrowserTitle('Portfolio');
    const [params] = useSearchParams();

    return (
        <Suspense fallback={<PageLayout.Skeleton sidebar aside controls />}>
            {
                params.get('managed-by') === 'OTHER'
                    ? <NewManagementsPage />
                    : <PortfolioPage />
            }
        </Suspense>
    );
}
